import React, { createContext, useContext, useEffect, useState } from "react";

const ViewCurrencyContext = createContext(null);

export function ViewCurrencyProvider({ children }) {
  const [viewCurrency, setViewCurrency] = useState(() => localStorage.getItem("viewCurrency") || "TRY");
  useEffect(() => { localStorage.setItem("viewCurrency", viewCurrency); }, [viewCurrency]);
  return (
    <ViewCurrencyContext.Provider value={{ viewCurrency, setViewCurrency }}>
      {children}
    </ViewCurrencyContext.Provider>
  );
}

export const useViewCurrency = () => useContext(ViewCurrencyContext);
